import React from 'react';
import cx from 'classnames';

import styles from './RadioInput.module.scss';

export interface Props {
  children?: React.ReactNode;
  className?: Parameters<typeof cx>[0];
  disabled?: boolean;
  id: string;
  /** Custom className to override or add styles to the input. */
  inputClassName?: Parameters<typeof cx>[0];
  inputValue?: string;
  labelClassName?: Parameters<typeof cx>[0];
  name?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value: boolean;
}

export const RadioInput: React.FC<Props> = ({
  children,
  className,
  disabled,
  id,
  inputClassName,
  inputValue,
  labelClassName,
  name,
  onChange,
  value,
}) => (
  <div
    className={cx(
      styles.wrapper,
      disabled && styles.disabled,
      value && styles.checked,
      className,
    )}
  >
    <input
      checked={value}
      className={cx(styles.input, inputClassName)}
      disabled={disabled}
      id={id}
      name={name}
      onChange={onChange}
      type='radio'
      value={inputValue}
    />
    <label className={cx(styles.label, labelClassName)} htmlFor={id}>
      {children}
    </label>
  </div>
);

RadioInput.displayName = 'RadioInput';
export default RadioInput;
export { styles };
